__turbopack_context__.v({
  "arisLogo": "_9ypQia_arisLogo",
  "header": "_9ypQia_header",
});
